module.exports = __webpack_public_path__ + "static/splash_overlay-01f854e50f28aba38f53a008a3320e8c.png";